import React, { FC, PropsWithChildren } from 'react'
import { styled } from 'styled-components'

export const RotatedTitleRoot = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const RotatedTitleContent = styled.div`
    transform: rotate(-90deg);
`

export interface RotatedTitleProps {
    style?: React.HTMLAttributes<HTMLDivElement>['style']
}

export const RotatedTitle: FC<PropsWithChildren<RotatedTitleProps>> = ({ children, style }) => {
    return (
        <RotatedTitleRoot style={style}>
            <RotatedTitleContent>{children}</RotatedTitleContent>
        </RotatedTitleRoot>
    )
}
